import * as React from 'react';
import { resolve } from 'inversify-react';

import { DataLocalService } from 'src/core/services/data-local.service';
import { Column, DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { FormatService } from 'src/core/services/format.service';
import { QuoteEntryListDataService } from 'src/app/accounting/suppliers/cost/parts/quote-entry-list.data';
import { ObjectUtils } from 'src/core/utils/object';
import { ToastNotifications } from 'src/core/ui/toast';
import { ZuluIcon } from 'src/app/shared/icon';

interface Props {
	currencyFormat: string;
	setBusy: (busy: boolean) => void;
	quoteEntryId: string;
}

interface State {
	breakdown: BreakdownEntry[];
}

export class BreakdownList extends React.Component<Props, State> {
	@resolve
	private formatService: FormatService;

	@resolve
	private toast: ToastNotifications;

	private quoteEntryListDataService: QuoteEntryListDataService;

	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			breakdown: []
		};
	}

	componentDidMount(): void {
		const { setBusy } = this.props;

		setBusy(true);
		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				setBusy(false);
			});
	}

	private async loadData(): Promise<void> {
		const { quoteEntryId } = this.props;
		this.quoteEntryListDataService = QuoteEntryListDataService.make();

		const breakdown = await this.quoteEntryListDataService.getBreakdown(quoteEntryId);

		this.setState({ breakdown });
	}

	render(): React.ReactNode {
		const { currencyFormat, setBusy } = this.props;
		const { breakdown } = this.state;
		const columns: Column[] = [
			{
				title: 'Product',
				key: 'productDisplayName',
				dataIndex: 'productDisplayName',
				width: 50
			},
			{
				title: 'Client',
				key: 'clientDisplayName',
				dataIndex: 'clientDisplayName',
				width: 50
			},
			{
				title: 'Cost',
				key: 'price',
				dataIndex: 'price',
				width: 50,
				render: (field: number) => this.formatService.toString('currency', field, currencyFormat),
			}
		];
		const dataSet = new DataLocalService<any>(breakdown);

		return (
			<DataTableView
				mode="display"
				rowKey={(m) => m.id}
				model={dataSet}
				columns={columns}
				setBusy={setBusy}
				hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hidePagination}
				selection={false}
				otherProps={{
					style: { marginLeft: '-20px', width: '50%' }
				}}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/suppliers/cost/parts/breakdown-list.tsx